export type IndentationType = 'space' | 'tab';
